import {Component, Input, OnInit} from '@angular/core';
import {ProductoPasarela} from '../../../../_models/producto-pasarela';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ListaService} from '../../../../_services/lista.service';
import {NavService} from '../../../../_services/_nav.service';
import {forkJoin, Observable} from 'rxjs';
import {Listas} from '../../../../_enums/enum';
import {slideCollapseAnimation} from '../../../../utils/slide-collapse.animation';
import {ProductoPasarelaContrato} from '../../../../_models/producto-pasarela-contrato';
import {ProductoPasarelaContratoService} from '../../../../_services/producto-pasarela-contrato.service';
import {PlantillaService} from '../../../../_services/plantilla.service';

@Component({
  selector: 'app-producto-pasarela-contratos',
  templateUrl: './producto-pasarela-contratos.component.html',
  styleUrl: './producto-pasarela-contratos.component.css',
  animations: [slideCollapseAnimation],
})
export class ProductoPasarelaContratosComponent  implements OnInit {
  @Input() isDetail: boolean = false;
  @Input() productoPasarela: ProductoPasarela;
  isLoading: boolean = true;
  records: ProductoPasarelaContrato[] = [];
  serviceContracts: SelectItem[] = [];
  templates: SelectItem[] = [];
  cols: any[] = [];
  rows: number = 10;

  showForm: boolean = false;
  form: FormGroup;
  submitted: boolean = false;
  saving: boolean = false;
  cdKey: string = 'producto-pasarela-contratos';

  constructor(
    private fb: FormBuilder,
    private service: ProductoPasarelaContratoService,
    private plantillaService: PlantillaService,
    private listService: ListaService,
    private navService: NavService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.cols = [
      { field: 'nombreContratosServicios', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_CONTRATO.LBL_TITULO'), sort: false },
      { field: 'nombrePlantilla', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_CONTRATO.LBL_PLANTILLA'), sort: false },
      { field: 'descripcion', header: this.navService.buscarMensaje('PRODUCTO_PASARELA_CONTRATO.LBL_DESCRIPCION'), sort: false },
    ];

    if(!this.isDetail) {
      this.cols.push({ field: 'acciones', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false });
    }

    this.loadData();
  }

  loadData(): void {
    forkJoin([
      this.service.getByIdProductoPasarelaEnabled(this.productoPasarela?.idProductoPasarela),
      this.listService.getMasterDetails(Listas.LISTAS_CONTRATOS_SERVICIOS),
      this.plantillaService.getAllEnabledAplicaContrato(),
    ]).subscribe({
      next: ([records, serviceContracts, templates]) => {
        this.records = records;
        this.serviceContracts = serviceContracts.map(e => ({label: e.nombre, value: e.idLista}));
        this.templates = templates.map(e => ({label: e.nombre, value: e.idPlantilla}));
        this.isLoading = false;
      },
    });
  }

  loadRecords(): void {
    this.isLoading = true;
    this.service.getByIdProductoPasarelaEnabled(this.productoPasarela?.idProductoPasarela).subscribe({
      next: (records) => {
        this.records = records;
        this.isLoading = false;
      },
    });
  }

  onCreateOrEdit(record?: ProductoPasarelaContrato): void {
    this.buildForm(record);
  }

  onDelete(record: ProductoPasarelaContrato): void {
    this.confirmationService.confirm({
      key: this.cdKey,
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      message: this.navService.buscarMensaje('MSG_ELIMINARCAMBIOS'),
      accept: () => {
        this.saving = true;
        record.indicadorHabilitado = false;
        this.service.update(record).subscribe({
          next: () => {
            this.navService.setMesage(2);
            this.saving = false;
            if(this.form && this.f.idProductoPasarelaContrato.value === record.idProductoPasarelaContrato) {
              this.showForm = false;
            }
            this.loadRecords();
          },
          error: () => {
            this.navService.setMesage(3);
            this.saving = false;
          },
        });
      },
    });
  }

  onCancel(): void {
    if(this.isFormDirty) {
      this.confirmationService.confirm({
        key: this.cdKey,
        header: this.navService.buscarMensaje('LBL_CAMBIOS_SIN_GUARDAR'),
        message: this.navService.buscarMensaje('MSG_CAMBIOS_SIN_GUARDAR'),
        accept: () => this.showForm = false,
      });
    } else {
      this.showForm = false;
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) return;

    this.saving = true;
    const record: ProductoPasarelaContrato = this.form.getRawValue();
    const request: Observable<ProductoPasarelaContrato> = this.isNewRecord ? this.service.create(record) : this.service.update(record);
    request.subscribe({
      next: () => {
        this.navService.setMesage(this.isNewRecord ? 1 : 2);
        this.saving = false;
        this.showForm = false;
        this.loadRecords();
      },
      error: () => {
        this.navService.setMesage(3);
        this.saving = false;
      },
    });
  }

  get isNewRecord(): boolean {
    return !this.f.idProductoPasarelaContrato.value;
  }

  get isFormDirty(): boolean {
    return !!this.form?.dirty;
  }

  get f() {
    return this.form.controls;
  }

  private buildForm(record?: ProductoPasarelaContrato): void {
    this.form = this.fb.group({
      idProductoPasarela: [record ? record.idProductoPasarela : this.productoPasarela?.idProductoPasarela],
      idProductoPasarelaContrato: [record ? record.idProductoPasarelaContrato : null],
      idContratosServicios: [record ? record.idContratosServicios : null, [Validators.required]],
      idPlantilla: [record ? record.idPlantilla : null, [Validators.required]],
      descripcion: [record ? record.descripcion : null, [Validators.required]],
      indicadorHabilitado: [record ? record.indicadorHabilitado : true],
    });
    this.submitted = false;
    this.showForm = true;
  }
}
